module.exports = __webpack_public_path__ + "static/media/NextU.b94d6deb.png";